import { createContext, useContext, ReactNode } from 'react';

interface LockContextType {
  hasPin: boolean;
  remainingTime: number;
  lockNow: () => void;
}

const LockContext = createContext<LockContextType | null>(null);

export function LockProvider({ 
  children, 
  hasPin, 
  remainingTime, 
  lockNow 
}: { 
  children: ReactNode;
  hasPin: boolean;
  remainingTime: number;
  lockNow: () => void;
}) {
  return (
    <LockContext.Provider value={{ hasPin, remainingTime, lockNow }}>
      {children}
    </LockContext.Provider>
  );
}

export function useLockContext() {
  const context = useContext(LockContext);
  if (!context) {
    return { hasPin: false, remainingTime: 30000, lockNow: () => {} };
  }
  return context;
}